import * as React from 'react'
import * as xss from 'xss'

interface IProps {
  html: string
}

const SafeInnerHtml = ({ html }: IProps) => {
  return <div dangerouslySetInnerHTML={{ __html: xss(html) }} />
}

export default SafeInnerHtml
